import { styled } from "@mui/system";
import { Box } from "@mui/material";

const FallbackPageStyles = styled(Box)(({ theme }) => ({
  "&.gridContainer": {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
  },
  "& .boxContainer": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  "& .title": {
    marginBottom: theme.spacing(2),
  },
  "& .buttonsContainer": {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(2),
    gap: theme.spacing(4),
  },
  "& .imageStyle": {
    [theme.breakpoints.down("md")]: {
      maxWidth: "30%",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "50%",
    },
    maxWidth: "20%",
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(8),
  },
  "& .midContainer": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export default FallbackPageStyles;
